export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand">
      <span className="brand-mark" aria-hidden="true">OM</span>
      {!compact && <span className="brand-name">Ops Matrix <small>CODEX STAGING</small></span>}
    </span>
  )
}
